<template>
  <div>
    <disqualifier :order-type="orderType" :orderStatus="0"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>

<script>
import Disqualifier from '@/views/quality/disqualification/Disqualifier.vue'

export default {
  components: { Disqualifier },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      orderType: { id: this.queryParam.value.business.orderTypeId }
    }
  },
  methods: {}
}
</script>